/** @flow */

import {
  GetClientShiftPatternsSuccess,
  GetClientShiftPatternsError,
} from "@modules/shared/constants/actions";
import * as shiftPatternReducers from "./reducers";
import initialState from "./state";
import type { ShiftPatternsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: ShiftPatternsState = initialState, action: Object): ShiftPatternsState => {
  const act = {
    [GetClientShiftPatternsSuccess]: shiftPatternReducers.onGetClientShiftPatternsSuccess,
    [GetClientShiftPatternsError]: shiftPatternReducers.onGetClientShiftPatternsError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
